import React from 'react';
import { Navigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import PropTypes from 'prop-types';

const ProtectedRoute = ({ element }) => {
  const authToken = Cookies.get('authToken');
  const requiresPasswordChange =
    Cookies.get('requiresPasswordChange') === 'true';

  if (!authToken) {
    console.warn('No auth token found. Redirecting to home...');
    return <Navigate to="/" />;
  }

  if (requiresPasswordChange) {
    return <Navigate to="/change-password" replace />;
  }

  return <div className="protected-route-container">{element}</div>;
};

ProtectedRoute.propTypes = {
  element: PropTypes.node.isRequired,
};

export default ProtectedRoute;
